import { createContext, useContext } from "react";
import type { QueueTrack } from "./types.ts";

type GridPlaybackApi = {
  /** Play `startTrackId` with the currently loaded grid rows as the queue. */
  playFromTrack: (startTrackId: string) => void;
  rowsAsQueue: () => QueueTrack[];
};

const GridPlaybackContext = createContext<GridPlaybackApi | null>(null);

export const GridPlaybackProvider = GridPlaybackContext.Provider;

export function useGridPlayback(): GridPlaybackApi | null {
  return useContext(GridPlaybackContext);
}
